/**
 * @generated SignedSource<<c9c1b975110c1de022aa8822e4381bf4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type scmpPwaBurgerMenuConfigAppConfigQuery$variables = Record<PropertyKey, never>;
export type scmpPwaBurgerMenuConfigAppConfigQuery$data = {
  readonly appConfig: {
    readonly json: unknown | null | undefined;
  } | null | undefined;
};
export type scmpPwaBurgerMenuConfigAppConfigQuery = {
  response: scmpPwaBurgerMenuConfigAppConfigQuery$data;
  variables: scmpPwaBurgerMenuConfigAppConfigQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "filter",
        "value": {
          "entityId": "scmp_pwa_burger_menu"
        }
      }
    ],
    "concreteType": "AppConfigs",
    "kind": "LinkedField",
    "name": "appConfig",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "json",
        "storageKey": null
      }
    ],
    "storageKey": "appConfig(filter:{\"entityId\":\"scmp_pwa_burger_menu\"})"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "scmpPwaBurgerMenuConfigAppConfigQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "scmpPwaBurgerMenuConfigAppConfigQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "07353cd5f11de8c2db61101d9b5455a7",
    "id": null,
    "metadata": {},
    "name": "scmpPwaBurgerMenuConfigAppConfigQuery",
    "operationKind": "query",
    "text": "query scmpPwaBurgerMenuConfigAppConfigQuery {\n  appConfig(filter: {entityId: \"scmp_pwa_burger_menu\"}) {\n    json\n  }\n}\n"
  }
};
})();

(node as any).hash = "ca9b160847310d9fd8662817493dbdcd";

export default node;
